import { isAxiosError } from "axios";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import { Tooltip } from "@mui/material";

const coloresEstados = [
  { id: 1, color: "bg-success" },
  { id: 0, color: "bg-danger" },
];

export const getColorEstado = (id) => {
  return coloresEstados.filter((col) => {
    if (col.id === id) {
      return col.color;
    }
  });
};

export const getEspecies = async (especies, setEspecies) => {
  setEspecies({ ...especies, loading: true });
  let response = await axios().get("especies");

  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setEspecies({ ...especies, data: data, loading: false });
      toast.success("Especies cargados", toastOptions);
    }

    if (!data && error) {
      setEspecies({ ...especies, error: error, loading: false });
      toast.error(error, toastOptions);
    }
  } else {
    setEspecies({ ...especies, loading: false, error: "Hubo un error inesperado" });
  }
};

export const dataTable = (data, setEspecies, especies) => {
  const columns = [
    { field: "id", headerName: "#", flex: 0.3, minWidth: 57 },
    {
      field: "estado_badge",
      headerName: "Estado",
      renderCell: (p) => {
        let col = getColorEstado(p.row.estado);
        return (
          <div>
            <span className={`badge ${col[0].color}`}>
              {p.row.estado == 0 ? "Inactivo" : "Activo"}
            </span>
          </div>
        );
      },
      minWidth: 76,
      flex: 0.4,
    },
    {
      field: "nombre",
      headerName: "Nombre",
      minWidth: 200,
      flex: 2,
    },
    {
      field: "boton",
      headerName: "Acciones",
      renderCell: (p) => {
        return (
          <div className="d-flex gap-3 align-items-center">
            <Tooltip title="Ver especie" arrow placement="left">
              <Link to={"/especie/" + p.row.id}>
                <VisibilityIcon color="action" />
              </Link>
            </Tooltip>

            <Tooltip title="Borrar especie" arrow placement="right">
              <div
                onClick={() => {
                  deleteEspecie(p.row.id, setEspecies, especies);
                }}
              >
                <DeleteIcon color="error" />
              </div>
            </Tooltip>
          </div>
        );
      },
      minWidth: 50,
      flex: 0.5,
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      estado_badge: d.estado.estado,
      estado: d.estado,
      nombre: d.nombre,
      boton: d.id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      d.id?.toString().toLowerCase().includes(value) ||
      d.estado_badge?.toLowerCase().includes(value) ||
      d.nombre?.toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const deleteEspecie = async (id, setEspecies, especies) => {
  setEspecies({ ...especies, loading: true });
  let response = await axios().delete(`especie/${id}`);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      const filterEspecies = especies.data.filter((especie) => especie.id != id);
      toast.success("Especie eliminada", toastOptions);
      setEspecies({ ...especies, loading: false, data: filterEspecies });
    }
    if (!data && error) {
      toast.error(error, toastOptions);
      setEspecies({ ...especies, loading: false });
    }
  } else {
    toast.error("Huo un error inesperado", toastOptions);
    setEspecies({ ...especies, loading: false });
  }
};
